// mycards strings (en).
const mycards = {
	mycards: {
		// Status tabs
		tabAll: 'All',
		tabDraft: 'Draft',
		tabSent: 'Sent',
		tabScheduled: 'Scheduled',
		tabWorkflow: 'Workflow',

		// View toggle
		gridView: 'Grid view',
		calendarView: 'Calendar view',

		// Search
		searchPlaceholder: 'Enter card title',

		// Date range filter
		last7Days: 'Last 7 Days',
		last15Days: 'Last 15 Days',
		last30Days: 'Last 30 Days',
		last2Months: 'Last 2 months',
		last6Months: 'Last 6 months',
		lastYear: 'Last year',
		allCardsRange: 'All cards',

		viewMore: 'View more',

		// Empty state
		emptyState: 'You do not have any cards yet. Click the button below to get started.',
		createNewCard: 'Create new card',

		// Folder bar
		foldersLabel: 'Folders',
		allCards: 'All cards',
		newFolder: 'New folder',
		addFolder: 'Add',
		folderNamePlaceholder: 'Folder name',
		addRemoveCards: 'Add / remove cards',
		renameFolderText: 'Rename folder "%{name}"',
		deleteFolderTitle: 'Delete "%{name}"?',
		deleteFolderText: 'The folder will be removed. Cards inside it are kept and just un-filed.',

		// Assign cards modal
		cardsInFolder: 'Cards in "%{name}"',
		selectedCount: '%{count} selected',
		searchCards: 'Search cards…',
		noCardsFound: 'No cards found.',
		untitledCard: 'Untitled card',
		btnSave: 'Save',
		btnSaving: 'Saving…',

		// Shared buttons
		btnCancel: 'Cancel',
		btnRename: 'Rename',
		btnDelete: 'Delete',
		btnNo: 'No',
		btnYes: 'Yes',
		btnEditAnyway: 'Edit Anyway',

		// Folder handler errors
		couldNotCreateFolder: 'Could not create folder',
		couldNotRenameFolder: 'Could not rename folder',
		couldNotDeleteFolder: 'Could not delete folder',

		// Card handler dialogs
		cardAlreadyDeliveredTitle: 'Card already delivered',
		cardAlreadyDeliveredText: 'You can clone this card to schedule a new one',
		workflowWarningTitle: 'This card is used in a workflow',
		workflowWarningText: 'Editing merge tags or content may break your existing workflows. Are you sure you want to continue?',
		openCardErrorTitle: 'Encountered a problem while opening this card. Please contact support',
		deleteCardTitle: 'Are you sure?',
		deleteCardText: 'Do you want to delete this card.',
		errorTitle: 'Error',
	} as Record<string, string>,
};
export default mycards;
